import React from 'react';
import './Farming.css';
import img1 from '../Assets/poultry.JPG'
import img2 from '../Assets/eggharvest.JPG'
import img3 from '../Assets/eggharvest1.JPG'
import img4 from '../Assets/henCoup.JPG'
import img17 from '../Assets/cropFarming.jpeg'
import img18 from '../Assets/cropFarmingimg.jpeg'

function Farming() {
  return (
    <div className="projects-container">
      <div className="projects-hero">
        <h1>Agricultural Initiatives</h1>
        <p>Transforming Lives Through Sustainable Farming</p>
      </div>
      
      <div className="project-content">
        <div className="farming-section">
          <div className='farmingflexbox'>
            <div className='farmingTextbox'>
              <h2>Mephibosheth Training Centre Farm</h2>
              <p>Volunteer Impact Initiative undertakes projects which focuses on plant (crop) and animal (poultry and rabbit) farming at the Mephibosheth Training Centre in the Central Region of Ghana.</p>
              <p>The farm plays a crucial role in providing food for the residents of the training centre, which supports physically and mentally challenged children and adults.</p>
              <p>Located in Gomoa Ankamu, the Mephibosheth Training Centre is dedicated to offering education, care, and opportunities for growth to individuals with disabilities.</p>
              <p>Volunteers are encouraged to bring their knowledge, experience, and skills in farming to contribute to the success of the project. Creativity and initiative are also valued as key components in driving positive outcomes.</p>
              
              <div className="impact-stats">
                <div className="stat">
                  <h3>200+</h3>
                  <p>Residents Supported</p>
                </div>
                <div className="stat">
                  <h3>5</h3>
                  <p>Farm Types</p>
                </div>
                <div className="stat">
                  <h3>50+</h3>
                  <p>Volunteers Yearly</p>
                </div>
              </div>
            </div>
            
            <div className='farmingImgGrid'>
              <img src={img1} alt='Crop farming at Mephibosheth Training Centre' className='farmingImg'/>
              <img src={img2} alt='Poultry farming project' className='farmingImg'/>
              <img src={img3} alt='Rabbit farming initiative' className='farmingImg'/>
              <img src={img4} alt='Farm volunteers at work' className='farmingImg'/>
              <img src={img17} alt='Training centre residents' className='farmingImg'/>
              <img src={img18} alt='Harvest from the farm' className='farmingImg'/>
            </div>
          </div>
        </div>
        
        <div className="call-to-action">
          <h2>Want to Get Involved?</h2>
          <p>Join our farming initiative and make a direct impact on the lives of people with disabilities</p>
          <a href='/VolunteerNow'><button className="cta-button">Become a Volunteer</button></a>
        </div>
      </div>
    </div>
  );
}

export default Farming;